var map = {
	"./de/common.json": 11932,
	"./de/index.json": 49559,
	"./en/common.json": 23172,
	"./en/index.json": 92549,
	"./es/common.json": 93078,
	"./es/index.json": 19783,
	"./fr/common.json": 36210,
	"./fr/index.json": 92475,
	"./zh/index.json": 73810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22744;